import React, { createContext, useContext, useState } from 'react';
import './Spinner.css';
// Create Context for Spinner
const SpinnerContext = createContext();

// Custom Hook to use Spinner
export const useSpinner = () => useContext(SpinnerContext);

// Spinner Provider Component
export function SpinnerProvider({ children }) {
  const [loading, setLoading] = useState(false); // State to control the spinner visibility

  return (
    <SpinnerContext.Provider value={{ loading, setLoading }}>
      {children}
      
      {/* If loading is true, show the spinner */}
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)', // semi-transparent background
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999, // Ensure it appears above everything else
          }}
        >
          {/* Spinner with animation */}
          <div className="spinner"></div>
        </div>
      )}
    </SpinnerContext.Provider>
  );
}
